import React from 'react';
import PropTypes from 'prop-types';
import {
  MARKETING_PARTNER_LISTING_STATUS_LANDLORD_INVITED,
  MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
} from 'common/marketingPartnerListingConstants';

import SrGoingToMarketCard from 'client/components/SrGoingToMarketCard/SrGoingToMarketCard';
import SrGoingToMarketLiveCard from 'client/components/SrGoingToMarketLiveCard/SrGoingToMarketLiveCard';

const SrDataTableMarketingPartnerListingsCard = ({
  marketingPartnerListing,
  partner,
  currentUser,
  onEdit,
  onEditWalkThroughFields,
  onEditMarketingPartnerListingDueDate,
  onEditFields,
  location,
  appUrl,
  reloadData,
}) => (
  <>
    {(marketingPartnerListing.walkthroughIssuesResolved !== false
      && (
        marketingPartnerListing.status === MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS
        || marketingPartnerListing.status === MARKETING_PARTNER_LISTING_STATUS_LANDLORD_INVITED
      ))
      ? (
        <SrGoingToMarketLiveCard
          marketingPartnerListing={marketingPartnerListing}
          currentUser={currentUser}
          onEdit={onEdit}
          onEditMarketingPartnerListingDueDate={onEditMarketingPartnerListingDueDate}
          onEditFields={onEditFields}
          onEditWalkThroughFields={onEditWalkThroughFields}
          location={location}
          appUrl={appUrl}
          reloadData={reloadData}
        />
      ) : (
        <SrGoingToMarketCard
          partnerSlug={partner.slug}
          marketingPartnerListing={marketingPartnerListing}
          currentUser={currentUser}
          onEdit={onEdit}
          onEditMarketingPartnerListingDueDate={onEditMarketingPartnerListingDueDate}
          reloadData={reloadData}
        />
      )}
  </>
);

SrDataTableMarketingPartnerListingsCard.propTypes = {
  partner: PropTypes.object.isRequired,
  marketingPartnerListing: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  onEditMarketingPartnerListingDueDate: PropTypes.func.isRequired,
  onEditFields: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onEditWalkThroughFields: PropTypes.func.isRequired,
  location: PropTypes.object,
  appUrl: PropTypes.string.isRequired,
  reloadData: PropTypes.func,
};

SrDataTableMarketingPartnerListingsCard.displayName = 'SrDataTableMarketingPartnerListingsCard';

export default SrDataTableMarketingPartnerListingsCard;
